import { Typography } from "antd";
import { FC } from "react";
import { ColSize, ContentSection } from "../../../../shared/components";
import { HomeIconsRender } from "../HomeIconsRender/HomeIconsRender";
import { SectionGroupButtonColor } from "../../../../shared/components/SectionGroupButtons/utils";
import { BranchGroup } from "../../../../shared/interfaces/services/get-home-services";
import { AlertComponent } from "../../../../shared/components/AlertComponent";

import './index.css';

interface GenericSectionProps {
    title: string;
    values: BranchGroup[] | undefined;
    color: SectionGroupButtonColor;
}

export const GenericSection: FC<GenericSectionProps> = ({title, values, color}) => {    
    return (
        values === undefined ? 
            <ColSize className="home-custom-error" size={100}>
                <AlertComponent className="custom-error-home" message={title} description={"No se encontro informacion"} type="warning"/>
            </ColSize>
        :
        values.length === 0 ? 
            <ColSize className="home-custom-error" size={100}>
                <AlertComponent className="custom-error-home" message={"Error al cargar " + title} description={"Hubo un error al tratar de cargar la seccion"} type="error"/>
            </ColSize>
        :
            <ContentSection>
                <Typography.Text style={{'marginBottom': "20px"}} className="home-dashboard__text-tree">{title}</Typography.Text>
                <HomeIconsRender color={color} values={values}/>
            </ContentSection>
    );
}
